export default class Ids {
  static readonly UTILITY_FRAME: string = 'cb-utility-frame';
  static readonly MASTER_FRAME: string = 'cb-master-frame';
  static readonly HOST_NAME: string = '__HOST__';
  static readonly CONTAINER: string = 'cb-container';
  static readonly CB_FRAME: string = 'cb-frame';
  static readonly CB_LOADER: string = 'cb-loader';
  static readonly CB_LOADER_HEADER: string = 'cb-loader-header';
  static readonly CB_HEADER_LOGO: string = 'cb-header-logo';
  static readonly CB_ERROR: string = 'cb-error';
  static readonly CB_LOADING_BAR: string = 'cb-loading-bar';
  static readonly CB_MODAL_CLOSE: string = 'cb-modal-close';
  static readonly CB_PLACE_HOLDER: string = 'cb-placeholder';
  static readonly CB_POPUP_CONSENT: string = 'cb-popup-consent';
  static readonly CB_PAYMENT_COMPONENTS: string = 'cb_payment_components';
  static readonly PC_FPC_V4: string = 'pc_fpc_v4';
  static readonly PC_INAPP_V4: string = 'pc_inapp_v4';
  static readonly CB_HP_V4: string = 'cb_hp_v4';
}
